var AppEmbedData_AppType = /* @__PURE__ */ ((AppEmbedData_AppType2) => {
  AppEmbedData_AppType2["PRODUCT"] = "PRODUCT";
  AppEmbedData_AppType2["EVENT"] = "EVENT";
  AppEmbedData_AppType2["BOOKING"] = "BOOKING";
  AppEmbedData_AppType2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_AppType2;
})(AppEmbedData_AppType || {});
var AppEmbedData_ImageStyles_Position = /* @__PURE__ */ ((AppEmbedData_ImageStyles_Position2) => {
  AppEmbedData_ImageStyles_Position2["START"] = "START";
  AppEmbedData_ImageStyles_Position2["END"] = "END";
  AppEmbedData_ImageStyles_Position2["TOP"] = "TOP";
  AppEmbedData_ImageStyles_Position2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_ImageStyles_Position2;
})(AppEmbedData_ImageStyles_Position || {});
var AppEmbedData_ImageStyles_AspectRatio = /* @__PURE__ */ ((AppEmbedData_ImageStyles_AspectRatio2) => {
  AppEmbedData_ImageStyles_AspectRatio2["SQUARE"] = "SQUARE";
  AppEmbedData_ImageStyles_AspectRatio2["RECTANGLE"] = "RECTANGLE";
  AppEmbedData_ImageStyles_AspectRatio2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_ImageStyles_AspectRatio2;
})(AppEmbedData_ImageStyles_AspectRatio || {});
var AppEmbedData_ImageStyles_Resizing = /* @__PURE__ */ ((AppEmbedData_ImageStyles_Resizing2) => {
  AppEmbedData_ImageStyles_Resizing2["FILL"] = "FILL";
  AppEmbedData_ImageStyles_Resizing2["FIT"] = "FIT";
  AppEmbedData_ImageStyles_Resizing2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_ImageStyles_Resizing2;
})(AppEmbedData_ImageStyles_Resizing || {});
var AppEmbedData_RibbonStyles_Placement = /* @__PURE__ */ ((AppEmbedData_RibbonStyles_Placement2) => {
  AppEmbedData_RibbonStyles_Placement2["IMAGE"] = "IMAGE";
  AppEmbedData_RibbonStyles_Placement2["PRODUCT_INFO"] = "PRODUCT_INFO";
  AppEmbedData_RibbonStyles_Placement2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_RibbonStyles_Placement2;
})(AppEmbedData_RibbonStyles_Placement || {});
var AppEmbedData_CardStyles_Type = /* @__PURE__ */ ((AppEmbedData_CardStyles_Type2) => {
  AppEmbedData_CardStyles_Type2["CONTAINED"] = "CONTAINED";
  AppEmbedData_CardStyles_Type2["FRAMELESS"] = "FRAMELESS";
  AppEmbedData_CardStyles_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_CardStyles_Type2;
})(AppEmbedData_CardStyles_Type || {});
var AppEmbedData_CardStyles_Alignment = /* @__PURE__ */ ((AppEmbedData_CardStyles_Alignment2) => {
  AppEmbedData_CardStyles_Alignment2["START"] = "START";
  AppEmbedData_CardStyles_Alignment2["CENTER"] = "CENTER";
  AppEmbedData_CardStyles_Alignment2["END"] = "END";
  AppEmbedData_CardStyles_Alignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_CardStyles_Alignment2;
})(AppEmbedData_CardStyles_Alignment || {});
var AppEmbedData_CardStyles_Layout = /* @__PURE__ */ ((AppEmbedData_CardStyles_Layout2) => {
  AppEmbedData_CardStyles_Layout2["STACKED"] = "STACKED";
  AppEmbedData_CardStyles_Layout2["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
  AppEmbedData_CardStyles_Layout2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return AppEmbedData_CardStyles_Layout2;
})(AppEmbedData_CardStyles_Layout || {});
export {
  AppEmbedData_AppType,
  AppEmbedData_CardStyles_Alignment,
  AppEmbedData_CardStyles_Layout,
  AppEmbedData_CardStyles_Type,
  AppEmbedData_ImageStyles_AspectRatio,
  AppEmbedData_ImageStyles_Position,
  AppEmbedData_ImageStyles_Resizing,
  AppEmbedData_RibbonStyles_Placement
};
//# sourceMappingURL=plugin_app_embed.enums.js.map
